// #region GENERAL ACTIONS

export const TOGGLE_SLIDING_WINDOW = 'TOGGLE_SLIDING_WINDOW';
export const SET_SLIDING_WINDOW = 'SET_SLIDING_WINDOW';
export const SET_COMPANY = 'SET_COMPANY';

// #endregion

// #region TOUR ACTIONS

export const TOGGLE_CUSTOMER_TOUR = 'TOGGLE_CUSTOMER_TOUR';
export const SET_TOUR_STEPS = 'SET_TOUR_STEPS';

// #endregion

// #region USER ACTIONS

export const SET_USER = 'SET_USER';
export const CLEAR_USER = 'CLEAR_USER';
export const SWITCH_USER = 'SWITCH_USER';
export const SET_USER_PRINTER = 'SET_USER_PRINTER';
export const SET_USER_COMPANY_INFO = 'SET_USER_COMPANY_INFO';
export const SET_INTERCOM_TOKEN = 'SET_INTERCOM_TOKEN';
// #endregion
export const SET_SESSION_TOKEN = 'SET_SESSION_TOKEN';
